var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApproveIcon = function SvgApproveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 14c-.893 0-1.409-.381-2.44-1.145C.15 8.85.68 4.102 3.026 2.663c1.788-1.097 3.349-.655 4.286.05.384.288.576.432.69.432s.305-.144.689-.433c.937-.704 2.498-1.146 4.286-.05 1.145.703 1.858 2.195 1.657 4.005"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.334 12s.667 0 1.333 1.334c0 0 2.118-3.333 4-4"
  })));
};
export default SvgApproveIcon;